import ItemList from "container/view/ItemListContainer.js";
import EventList from "container/view/EventListContainer.js";
import MuseumTickets from "container/view/MuseumTicketsContainer.js";
import Museum from "container/view/MuseumContainer.js";
import Contacts from "container/view/ContactsContainer.js";
import Payment from "container/view/PaymentContainer.js";
import InformationList from "container/view/InformationListContainer.js";
import ThankYou from "container/view/ThankYouContainer.js";

// @material-ui/icons
// import UserListIcon from "@material-ui/icons/Person";
// import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";

/* ex: http://localhost:3000/[museo_name]/emma-shopping/list */
function routesCustom(routeNameCustom = "emma-shopping") {
  return [
    /*    {
      id: "cart",
      // path: "/:id/delivery/cart",
      path: "/cart",
      name: "routes.cart",
      // icon: ShoppingBasketIcon,
      component: Cart,
      // layout: "",
      layout: `/:id`
    },*/
    {
      id: "list",
      path: "/list",
      name: "routes.list",
      // icon: UserListIcon,
      component: ItemList,
      layout: `/:id`
    },
    {
      id: "tickets",
      path: "/tickets",
      name: "routes.tickets",
      // icon: UserListIcon,
      component: MuseumTickets,
      layout: `/:id`
    },
    {
      id: "event",
      path: "/event/:id/:home",
      name: "routes.event",
      // icon: UserListIcon,
      component: EventList,
      layout: `/:id`
    },
    {
      id: "shop",
      path: "/shop/:home",
      name: "routes.list",
      // icon: UserListIcon,
      component: Museum,
      layout: `/:id`
    },
    {
      id: "information",
      path: "/information/:home",
      name: "routes.information",
      // icon: UserListIcon,
      component: InformationList,
      layout: `/:id`
    },
    {
      id: "contacts",
      path: "/contacts/:home",
      name: "routes.contacts",
      // icon: ShoppingBasketIcon,
      component: Contacts,
      layout: `/:id`
    },
    {
      id: "payment",
      path: "/payment/:home",
      name: "routes.payment",
      // icon: ShoppingBasketIcon,
      component: Payment,
      layout: `/:id`
    },
    {
      id: "thank-you",
      path: "/thank-you/:home",
      name: "routes.thank-yiu",
      // icon: ShoppingBasketIcon,
      component: ThankYou,
      layout: `/:id`
    },
    {
      redirect: true,
      id: "redirect",
      path: `/:id`,
      pathTo: `/:id/shop/with-tabs`,
      name: "routes.list"
    }
  ];
}

export default routesCustom;
